<div class="modal-header">
    <h5 class="modal-title text-white">Confirm send</h5>
</div>
<div class="modal-body" data-testid="confirm-modal-body">
    <p class="mb-0">Are you sure you want to send this template to the user?</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="back()" [disabled]="sending" data-testid="confirm-back-btn">No, cancel</button>
    <button type="button" class="btn btn-success" (click)="send()" [disabled]="sending" #sendBtn data-testid="confirm-send-btn">
        <span *ngIf="sending" class="spinner-border spinner-border-sm me-1" role="status"></span>
        Yes, send
    </button>
</div>
